module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_Manchester.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_Manchester.png
// module id = 2086
// module chunks = 4